export const categories = [
  {
    id: "antiscalants",
    name: "Antiscalants",
    description: "Prevent scale formation on RO/NF membranes",
    icon: "Beaker",
    image: "https://axeonsupply.com/cdn/shop/collections/Antiscalants_480x.png",
    available: true
  },
  {
    id: "antifoulants",
    name: "Antifoulants",
    description: "Control biological and organic fouling",
    icon: "Shield",
    image: "https://axeonsupply.com/cdn/shop/collections/sjiud6ublimcxx3zgbat_500x500_e2b_480x.png",
    available: true
  },
  {
    id: "cleaners",
    name: "Cleaners",
    description: "Remove deposits and restore membrane performance",
    icon: "Sparkles",
    image: "https://axeonsupply.com/cdn/shop/collections/Cleaners_480x.png",
    available: true
  },
  {
    id: "preservatives",
    name: "Preservatives",
    description: "Protect membranes during storage and shutdown",
    icon: "Archive",
    image: "https://axeonsupply.com/cdn/shop/collections/M-100_0308_500x500_49c15aaa-14df_480x.png",
    available: true
  }
];